import {Prescription} from 'types';
import styles from './EditModal.module.scss';
import Modal from 'components/Modal';
import Typography from 'components/Typography';
import PlusComponent from 'components/PlusComponent';
import Select from 'components/Select';
import {useEditModal} from './useEditModal';
import {Fragment} from 'react/jsx-runtime';
import {NewProduct} from 'pages/Products/Products';
import {useState} from 'react';
import Button from 'components/Button';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  product?: Prescription | Prescription[];
  refetch: () => void;
  requestId: number;
  editType: 'service' | 'product' | 'none';
}

function EditModal({
  isOpen,
  onClose,
  product,
  refetch: refetchOrder,
  requestId,
  editType,
}: Props) {
  const {
    productList,
    serviceList,
    isLoading,
    refetchOptions,
    updateRequestProducts,
    setItemIds,
    itemIds,
    // initialItemIds,
    error,
    // setError,
  } = useEditModal({
    isOpen,
    requestId,
    type: editType === 'product' ? 'product' : 'service',
    product,
    refetchOrder,
    onClose,
  });
  const [addNewModalType, setAddNewModalType] = useState<
    'product' | 'service' | 'none'
  >('none');

  return (
    <>
      <Modal
        isOpen={isOpen}
        onClose={onClose}
        onRequestClose={onClose}
        showCloseButton={true}
        className={styles.list_wrapper}
      >
        <Typography variant="h2">Edit {editType}</Typography>

        {editType === 'service' && (
          <Fragment>
            <div className={styles.label}>
              <div>Service</div>
              <PlusComponent
                onClick={() => {
                  setAddNewModalType('service');
                }}
              />
            </div>
            <Select
              placeholder="Click To Select"
              menuPosition="fixed"
              isLoading={isLoading}
              onChange={(item) => {
                if (Array.isArray(item)) {
                  setItemIds(item.map((item) => item.value));
                }
              }}
              value={
                itemIds.length > 0
                  ? serviceList
                      ?.filter((item) => itemIds.includes(Number(item.value)))
                      .map((item) => ({
                        value: Number(item.value),
                        label: item.label,
                      }))
                  : undefined
              }
              // @ts-ignore
              isMulti={true}
              isSearchable={true}
              options={serviceList}
            />
            {error && (
              <div style={{color: 'red', marginTop: '8px', fontSize: '14px'}}>
                {error}
              </div>
            )}
          </Fragment>
        )}

        {editType === 'product' && (
          <Fragment>
            <div className={styles.label}>
              <div>Product</div>
              <PlusComponent
                onClick={() => {
                  setAddNewModalType('product');
                }}
              />
            </div>
            <Select
              placeholder="Click To Select"
              menuPosition="fixed"
              onChange={(item) => {
                if (Array.isArray(item)) {
                  setItemIds(item.map((item) => item.value));
                }
              }}
              value={
                itemIds.length > 0
                  ? productList
                      ?.filter((item) => itemIds.includes(Number(item.value)))
                      .map((item) => ({
                        value: item.value,
                        label: item.label,
                      }))
                  : undefined
              }
              isSearchable={true}
              // @ts-ignore
              isMulti={true}
              isLoading={isLoading}
              options={productList}
            />
          </Fragment>
        )}
        <div className={styles.button_container}>
          <Button
            color="blue"
            size="md"
            loading={updateRequestProducts.isLoading}
            onClick={() => {
              updateRequestProducts.mutate();
            }}
          >
            Save
          </Button>
        </div>
      </Modal>
      <NewProduct
        isTypeDisabled
        productType={addNewModalType === 'product' ? 'product' : 'service'}
        visible={addNewModalType !== 'none'}
        onClose={() => setAddNewModalType('none')}
        onSuccess={() => {
          setAddNewModalType('none');
          refetchOptions();
        }}
      />
    </>
  );
}
export default EditModal;
